import { useState, useEffect, useContext } from 'react'
import { FiEdit } from 'react-icons/fi'
import { addDoc, collection, getDoc, getDocs, query, orderBy, where, doc } from 'firebase/firestore'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { AuthContext } from '../../contexts/auth'
import { db } from '../../services/firebaseConnection'

import { Content } from './styles'

const listRefDiscipline = collection(db, "discipline")
const listRefSubject = collection(db, "subject")
const listRefOrganizer = collection(db, "organizer")
const listRefInstitution = collection(db, "institution")
const listRefProfession = collection(db, "profession")
const listRefProfessionalQualification = collection(db, "professionalQualification")
const listRefWorkspace = collection(db, "workspace")

export function RegisterQuestion() {
  const { user } = useContext(AuthContext)
  const { id } = useParams()
  console.log("ID: ", id)

  const [question, setQuestion] = useState('')
  const [commentQuestion, setCommentQuestion] = useState('')
  const [answer, setAnswer] = useState('')
  console.log("ANSWER: ", answer)
  const [answer2, setAnswer2] = useState('')
  const [answer3, setAnswer3] = useState('')
  const [answer4, setAnswer4] = useState('')
  const [answer5, setAnswer5] = useState('')
  const [answerTrueFalse, setAnswerTrueFalse] = useState('')
  //console.log("AnswerTrueFalse: ", answerTrueFalse)
  const [answerTrueFalse2, setAnswerTrueFalse2] = useState('')
  const [answerTrueFalse3, setAnswerTrueFalse3] = useState('')
  const [answerTrueFalse4, setAnswerTrueFalse4] = useState('')
  const [answerTrueFalse5, setAnswerTrueFalse5] = useState('')
  const [totalAnswers, setTotalAnswers] = useState([])
  const [referenceLink, setReferenceLink] = useState('')
  //console.log(totalAnswers)

  const [discipline, setDiscipline] = useState([])
  const [disciplineSaved, setDisciplineSaved] = useState('')
  //console.log(disciplineSaved)
  const [subject, setSubject] = useState([])
  const [subjectSaved, setSubjectSaved] = useState('')
  //console.log(subjectSaved)
  const [year, setYear] = useState('')
  const [organizer, setOrganizer] = useState([])
  const [organizerSaved, setOrganizerSaved] = useState('')
  //console.log(organizerSaved)
  const [institution, setInstitution] = useState([])
  const [institutionSaved, setInstitutionSaved] = useState('')
  //console.log(institutionSaved)
  const [profession, setProfession] = useState([])
  const [professionSaved, setProfessionSaved] = useState('')
  //console.log(professionSaved)
  const [professionalQualification, setProfessionalQualification] = useState([])
  const [professionalQualificationSaved, setProfessionalQualificationSaved] = useState('')
  //console.log(professionalQualificationSaved)
  const [difficulty, setDifficulty] = useState('')
  const [workspace, setWorkspace] = useState([])
  const [workspaceSaved, setWorkspaceSaved] = useState('')
  const [modality, setModality] = useState('')
  const [questionNull, setQuestionNull] = useState(false)
  //console.log("QuestionsNull: ", questionNull)

  const [loadingDiscipline, setLoadingDiscipline] = useState(true)
  const [loadingSubject, setLoadingSubject] = useState(true)
  const [loadingOrganizer, setLoadingOrganizer] = useState(true)
  const [loadingInstitution, setLoadingInstitution] = useState(true)
  const [loadingProfession, setLoadingProfession] = useState(true)
  const [loadingProfessionalQualification, setLoadingProfessionalQualification] = useState(true)
  const [loadingWorkspace, setLoadingWorkspace] = useState(true)

  const [disciplineSelected, setDisciplineSelected] = useState(0)

  useEffect(() => {

    async function loadingSubject() {
      const querySnapshot = await getDocs(listRefSubject)
        .then((snapshot) => {
          const lista = [];

          snapshot.forEach((doc) => {
            const subjectData = doc.data();

            // Verifica se o documento está associado à disciplina desejada
            if (subjectData.discipline === disciplineSaved) {
              lista.push({
                id: doc.id,
                subject: subjectData.subject,
                discipline: subjectData.discipline
              });
            }
          });

          if (lista.length === 0) {
            setDiscipline([{ id: 1, subject: "Nenhuma disciplina encontrada para esta disciplina" }]);
            setLoadingDiscipline(false);
            return;
          }

          setSubject(lista);
          setLoadingSubject(false);
        })
        .catch((err) => {
          console.log(err);
          setSubject([{ id: 1, subject: "Algo de errado" }]);
          setLoadingSubject(false);
        });
    }

    loadingSubject()

  }, [disciplineSaved])

  useEffect(() => {
    async function loadingDiscipline() {
      const querySnapshot = await getDocs(listRefDiscipline)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              discipline: doc.data().discipline
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setDiscipline([{ id: 1, discipline: "Algo de errado" }])
            setLoadingDiscipline(false)
            return
          }

          setDiscipline(lista)
          setLoadingDiscipline(false)
        })
        .catch((err) => {
          console.log(err)
          setDiscipline([{ id: 1, discipline: "Algo de errado" }])
          setLoadingDiscipline(false)
        })
    }

    loadingDiscipline()

    // async function loadingSubject() {
    //   const querySnapshot = await getDocs(listRefSubject)
    //     .then((snapshot) => {
    //       //console.log(snapshot.docs)

    //       let lista = []

    //       snapshot.forEach((doc) => {
    //         lista.push({
    //           id: doc.id,
    //           subject: doc.data().subject
    //         })
    //       })

    //       //console.log(lista)

    //       if (snapshot.docs.size === 0) {
    //         setDiscipline([{ id: 1, discipline: "Algo de errado" }])
    //         setLoadingDiscipline(false)
    //         return
    //       }

    //       setSubject(lista)
    //       setLoadingSubject(false)
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       setSubject([{ id: 1, discipline: "Algo de errado" }])
    //       setLoadingSubject(false)
    //     })
    // }

    // loadingSubject()

    async function loadingOrganizer() {
      const querySnapshot = await getDocs(listRefOrganizer)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              organizer: doc.data().organizer
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setOrganizer([{ id: 1, discipline: "Algo de errado" }])
            setLoadingOrganizer(false)
            return
          }

          setOrganizer(lista)
          setLoadingOrganizer(false)
        })
        .catch((err) => {
          console.log(err)
          setOrganizer([{ id: 1, discipline: "Algo de errado" }])
          setLoadingOrganizer(false)
        })
    }

    loadingOrganizer()

    async function loadingInstitution() {
      const querySnapshot = await getDocs(listRefInstitution)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              institution: doc.data().institution
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setInstitution([{ id: 1, discipline: "Algo de errado" }])
            setLoadingInstitution(false)
            return
          }

          setInstitution(lista)
          setLoadingInstitution(false)
        })
        .catch((err) => {
          console.log(err)
          setInstitution([{ id: 1, discipline: "Algo de errado" }])
          setLoadingInstitution(false)
        })
    }

    loadingInstitution()

    async function loadingProfession() {
      const querySnapshot = await getDocs(listRefProfession)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              profession: doc.data().profession
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setProfession([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfession(false)
            return
          }

          setProfession(lista)
          setLoadingProfession(false)
        })
        .catch((err) => {
          console.log(err)
          setProfession([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfession(false)
        })
    }

    loadingProfession()

    async function loadingProfessionalQualification() {
      const querySnapshot = await getDocs(listRefProfessionalQualification)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              professionalQualification: doc.data().professionalQualification
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfessionalQualification(false)
            return
          }

          setProfessionalQualification(lista)
          setLoadingProfessionalQualification(false)
        })
        .catch((err) => {
          console.log(err)
          setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfessionalQualification(false)
        })
    }

    loadingProfessionalQualification()

    async function loadingWorkspace() {
      const querySnapshot = await getDocs(listRefWorkspace)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              workspace: doc.data().workspace
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setWorkspace([{ id: 1, discipline: "Algo de errado" }])
            setLoadingWorkspace(false)
            return
          }

          setWorkspace(lista)
          setLoadingWorkspace(false)
        })
        .catch((err) => {
          console.log(err)
          setWorkspace([{ id: 1, discipline: "Algo de errado" }])
          setLoadingWorkspace(false)
        })
    }

    loadingWorkspace()

  }, [])

  function handleChangeDiscipline(e) {
    //setDiscipline(e.target.value)
    setDisciplineSaved(discipline[e.target.value].discipline)
  }

  function handleChangeSubject(e) {
    //setDiscipline(e.target.value)
    setSubjectSaved(subject[e.target.value].subject)
  }

  function handleChangeYear(e) {
    //setDiscipline(e.target.value)
    setYear(e.target.value)
  }

  function handleChangeOrganizer(e) {
    //e.prevetDefault()
    setOrganizerSaved(organizer[e.target.value].organizer)
  }

  function handleChangeInstitution(e) {
    setInstitutionSaved(institution[e.target.value].institution)
  }

  function handleChangeProfession(e) {
    setProfessionSaved(profession[e.target.value].profession)
  }

  function handleChangeDifficulty(e) {
    setDifficulty(e.target.value)
  }

  function handleChangeProfessionalQualification(e) {
    setProfessionalQualificationSaved(professionalQualification[e.target.value].professionalQualification)
  }

  function handleChangeWorkspace(e) {
    setWorkspaceSaved(workspace[e.target.value].workspace)
  }

  function handleChangeAnswer(e) {
    //console.log("TRUE/FALSE: ", e.target.value)
    setAnswerTrueFalse(e.target.value)

  }

  function handleChangeAnswer2(e) {
    setAnswerTrueFalse2(e.target.value)
    //console.log("2" + e.target.value)
  }

  function handleChangeAnswer3(e) {
    setAnswerTrueFalse3(e.target.value)
    //console.log("3" + e.target.value)
  }

  function handleChangeAnswer4(e) {
    setAnswerTrueFalse4(e.target.value)
    //console.log("4" + e.target.value)
  }

  function handleChangeAnswer5(e) {
    setAnswerTrueFalse5(e.target.value)
    //console.log("5" + e.target.value)
  }

  function handleQuestionNull(e) {
    //console.log(e)
    setQuestionNull(true)
  }

  function handleChangeModality(e) {
    setModality(e.target.value)
  }

  async function handleRegisterQuestion(e) {
    e.preventDefault()

    const firstDigit = Math.floor(Math.random() * 2) + 2; // Gera um número entre 2 e 9
    const remainingDigits = Math.floor(Math.random() * 1000000); // Gera um número entre 0 e 999999
    const sevenDigitNumber = parseInt(firstDigit.toString() + remainingDigits.toString().padStart(6, '0'));

    const q = sevenDigitNumber
    console.log("q: ", q)

    const idOption1 = Math.random()
    const idOption2 = Math.random()
    const idOption3 = Math.random()
    const idOption4 = Math.random()
    const idOption5 = Math.random()

    if (question !== '') {
      await addDoc(collection(db, "questions"), {
        enunciation: question,
        q: q,
        options: {
          A: {
            text: answer,
            isCorrect: answerTrueFalse,
            idOption: idOption1
          },
          B: {
            text: answer2,
            isCorrect: answerTrueFalse2,
            idOption: idOption2
          },
          C: {
            text: answer3,
            isCorrect: answerTrueFalse3,
            idOption: idOption3
          },
          D: {
            text: answer4,
            isCorrect: answerTrueFalse4,
            idOption: idOption4
          },
          E: {
            text: answer5,
            isCorrect: answerTrueFalse5,
            idOption: idOption5
          }
        },
        comments: commentQuestion,
        isNull: questionNull,
        referenceLink: referenceLink,
        modality: "Multipla-escolha",
        created: new Date(),
        discipline: disciplineSaved,
        subject: subjectSaved,
        year: year,
        organizer: organizerSaved,
        institution: institutionSaved,
        profession: professionSaved,
        difficulty: difficulty,
        professionalQualification: professionalQualificationSaved,
        workspace: workspaceSaved
      })
        .then(() => {
          setQuestion('')
          setCommentQuestion('')
          setAnswer('')
          setAnswer2('')
          setAnswer3('')
          setAnswer4('')
          setAnswer5('')
          setAnswerTrueFalse()
          setAnswerTrueFalse2()
          setAnswerTrueFalse3()
          setAnswerTrueFalse4()
          setAnswerTrueFalse5()
          setQuestionNull(false)



          toast.success("Questão e respostas salvas com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova questão")
        })
    } else {
      toast.error("Algo de errado aconteceu, verifique e tente novamente")
    }
  }

  useEffect(() => {
    async function getQuestions() {
      await getDocs(collection(db, "questions"))
        .then((snapshot) => {
          let list = []

          console.log("snapshot: ", snapshot)

          snapshot.forEach((doc) => {
            list.push({
              enunciation: doc.data().enunciation,
              options: doc.data().options
            })
          })

          if (id) {
            loadId(list)
          }
        })
        .catch((err) => {
          console.log({ err: err })
        })
    }

    getQuestions()
  }, [id])

  async function loadId(list) {

    await getDoc(doc(db, "questions", id))
      .then((snapshot) => {
        console.log("snapshot-snapshot: ", snapshot)
        setQuestion(snapshot.data().enunciation)
        setCommentQuestion(snapshot.data().comments)
        setReferenceLink(snapshot.data().referenceLink)
        // setAnswer(snapshot.data().options)
        // setAnswer2(snapshot.data().answer2)
        // setAnswer3(snapshot.data().nswer3)
        // setAnswer4(snapshot.data().nswer4)
        // setAnswer5(snapshot.data().nswer5)
      })
      .catch((err) => {
        console.log({ err: err })
      })
  }


  return (
    <>
      <Header />
      <Content>
        <Title name="Cadastrar Questão">
          <FiEdit size={25} />
        </Title>

        <div className='container'>

          <form >
            <label>Categorias</label>
            <div className='box-categorys'>
              {
                loadingDiscipline ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeDiscipline} >
                    {discipline.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.discipline}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingSubject ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeSubject} >
                    {subject.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.subject}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingOrganizer ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeOrganizer} >
                    {organizer.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.organizer}
                        </option>
                      )
                    })}
                  </select>
                )
              }

              {
                loadingInstitution ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeInstitution} >
                    {institution.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.institution}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              <select onChange={handleChangeYear}>
                <option>Selecione o Ano</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
              </select>
              {
                loadingProfession ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeProfession} >
                    {profession.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.profession}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              <select onChange={handleChangeDifficulty}>
                <option>Selecione o Nível</option>
                <option value="Fundamental" >Fundamental</option>
                <option value="Medio" >Médio</option>
                <option value="Superior" >Superior</option>
              </select>
              {
                loadingProfessionalQualification ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeProfessionalQualification} >
                    {professionalQualification.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.professionalQualification}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingWorkspace ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeWorkspace} >
                    {workspace.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.workspace}
                        </option>
                      )
                    })}
                  </select>
                )
              }

            </div>
            <div className='question-null'>
              <input
                type="checkbox"
                onChange={(e) => setQuestionNull(e.target.checked)}
                checked={questionNull}
              />
              <label>Questão Nula</label>
            </div>
            <label>Pergunta</label>
            <textarea
              type="text"
              placeholder="Escreva o enunciado da questão"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <textarea
              type="text"
              placeholder='Escreva o comentário da questão aqui'
              value={commentQuestion}
              onChange={(e) => setCommentQuestion(e.target.value)}
            />
            <div className='box-question-answer'>
              <label>Link de Referência</label>
              <input
                type="url"
                value={referenceLink}
                onChange={(e) => setReferenceLink(e.target.value)}
                placeholder='link relacionado ao conteudo'
              />
            </div>
            <div>
              <label>Resposta 1</label>
              <div className='box-question-answer'>
                <input
                  placeholder='Escreva a resposta'
                  type='text'
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                />

                <div className='box-answer'>
                  <div className='answer'>
                    <label>Verdadeiro</label>
                    <input
                      type='radio'
                      name='radio'
                      id='true'
                      value='true'
                      onChange={handleChangeAnswer}
                      checked={answerTrueFalse === 'true'}
                    />
                  </div>
                  <div className='answer'>
                    <label>Falso</label>
                    <input
                      type='radio'
                      name='radio'
                      id='false'
                      value='false'
                      onChange={handleChangeAnswer}
                      checked={answerTrueFalse === 'false'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>Resposta 2</label>
              <div className='box-question-answer'>
                <input
                  placeholder='Escreva a resposta'
                  type='text'
                  value={answer2}
                  onChange={(e) => setAnswer2(e.target.value)}
                />

                <div className='box-answer'>
                  <div className='answer'>
                    <label>Verdadeiro</label>
                    <input
                      type='radio'
                      name='radio2'
                      id='true'
                      value='true'
                      onChange={handleChangeAnswer2}
                      checked={answerTrueFalse2 === 'true'}
                    />
                  </div>
                  <div className='answer'>
                    <label>Falso</label>
                    <input
                      type='radio'
                      name='radio2'
                      id='false'
                      value='false'
                      onChange={handleChangeAnswer2}
                      checked={answerTrueFalse2 === 'false'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>Resposta 3</label>
              <div className='box-question-answer'>
                <input
                  placeholder='Escreva a resposta'
                  type='text'
                  value={answer3}
                  onChange={(e) => setAnswer3(e.target.value)}
                />

                <div className='box-answer'>
                  <div className='answer'>
                    <label>Verdadeiro</label>
                    <input
                      type='radio'
                      name='radio3'
                      id='true'
                      value='true'
                      onChange={handleChangeAnswer3}
                      checked={answerTrueFalse3 === 'true'}
                    />
                  </div>
                  <div className='answer'>
                    <label>Falso</label>
                    <input
                      type='radio'
                      name='radio3'
                      id='false'
                      value='false'
                      onChange={handleChangeAnswer3}
                      checked={answerTrueFalse3 === 'false'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>Resposta 4</label>
              <div className='box-question-answer'>
                <input
                  placeholder='Escreva a resposta'
                  type='text'
                  value={answer4}
                  onChange={(e) => setAnswer4(e.target.value)}
                />

                <div className='box-answer'>
                  <div className='answer'>
                    <label>Verdadeiro</label>
                    <input
                      type='radio'
                      name='radio4'
                      id='true'
                      value='true'
                      onChange={handleChangeAnswer4}
                      checked={answerTrueFalse4 === 'true'}
                    />
                  </div>
                  <div className='answer'>
                    <label>Falso</label>
                    <input
                      type='radio'
                      name='radio4'
                      id='false'
                      value='false'
                      onChange={handleChangeAnswer4}
                      checked={answerTrueFalse4 === 'false'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label>Resposta 5</label>
              <div className='box-question-answer'>
                <input
                  placeholder='Escreva a resposta'
                  type='text'
                  value={answer5}
                  onChange={(e) => setAnswer5(e.target.value)}
                />

                <div className='box-answer'>
                  <div className='answer'>
                    <label>Verdadeiro</label>
                    <input
                      type='radio'
                      name='radio5'
                      id='true'
                      value='true'
                      onChange={handleChangeAnswer5}
                      checked={answerTrueFalse5 === 'true'}
                    />
                  </div>
                  <div className='answer'>
                    <label>Falso</label>
                    <input
                      type='radio'
                      name='radio5'
                      id='false'
                      value='false'
                      onChange={handleChangeAnswer5}
                      checked={answerTrueFalse5 === 'false'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <button onClick={handleRegisterQuestion} >Cadastrar </button>
          </form>
          {/* <button type='submit' onClick={handleRegisterQuestion} >Cadastrar</button> */}
          {/* <ul>
            <strong>Pergunstas e Respostas Salvas:</strong>
            {totalAnswers.map((i) => {
              //console.log(i)
              return (
                <>
                  <li>Perguntra: {i.answer}</li>
                  <i>Resposta: {i.answerTrueFalse}</i>
                </>
              )
            })}
          </ul> */}
        </div>


      </Content >
    </>
  )
}